import {
    faCheckCircle,
    faExclamationTriangle,
    faInfoCircle,
    faWarning,
} from '@fortawesome/free-solid-svg-icons';
import { ToastData } from './Toast';

export const TOAST_PROPERTIES: Pick<ToastData, 'type' | 'icon'>[] = [
    {
        type: 'success',
        icon: faCheckCircle,
    },
    {
        type: 'danger',
        icon: faExclamationTriangle,
    },
    {
        type: 'info',
        icon: faInfoCircle,
    },
    {
        type: 'warning',
        icon: faWarning,
    },
];
